import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullCloud2 extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={51} width={82}>
        <g fill="none" fillRule="evenodd" fillOpacity="0.2">
          <g transform="translate(-562 -258)" fill="#EAF7FC">
            <g transform="translate(-18 44)">
              <g transform="translate(0 68)">
                <path d="M589.613376,174.634491 L591.631249,174.634491 C591.41807,173.7723 591.294394,172.871067 591.294394,171.935671 C591.294394,166.202103 595.567729,161.554408 600.840236,161.554408 C602.755588,161.554408 604.536687,162.175022 606.031378,163.230799 C607.399138,153.433548 614.001977,146 621.946539,146 C630.445202,146 637.407678,154.504779 638.069182,165.313071 C639.086256,164.641213 640.22375,164.253227 641.432847,164.253227 C645.672821,164.253227 649.110529,168.900923 649.110529,174.634491 L652.335058,174.634491 C657.622211,174.634491 661.948433,179.43673 661.948433,185.306947 L661.948433,186.091866 C661.948433,191.962083 657.622211,196.764323 652.335058,196.764323 L589.613376,196.764323 C584.326222,196.764323 580,191.962083 580,186.091866 L580,185.306947 C580,179.43673 584.326222,174.634491 589.613376,174.634491" />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullCloud2.displayName = "NullCloud2";
NullCloud2.vstuiName = "Icon";

export default NullCloud2;
